import React from "react";
import { useTranslation } from "src/context/Translations/context";
import IComponentSelect from "react-common-components/dist/components/Select/interface";
import Select from "src/components/Select";

const LovDelimiter: React.FC<Omit<IComponentSelect,"options">> = ({
	name,
	control,
	label,
	defaultValue,	
	...rest
}) => {
	const { translate} = useTranslation();
	return (
		<Select
			control={control}
			name={name}
			label={label||translate("Delimitador")}
			options={[
				{ value: "|", label: "Pipe (|)" },
				{ value: ";", label: `${translate("Ponto e vírgula")} (;)` },
				{ value: "\t", label: `${translate("Tabulação")} (\t)` },
				{ value: ",", label: `${translate("Vírgula")} (,)` }
			]}
			defaultValue={defaultValue||";"}
			{...rest}
		/>
	);
};

export default LovDelimiter;
